module.exports = __webpack_public_path__ + "img/quad_diagram.3fd210f7.svg";